import React from 'react';
import { FormSection } from './FormSection';
import { Grid, Skeleton as MuiSkeleton } from '@mui/material';

export const Skeleton = () => (
    <>
        <FormSection title={<MuiSkeleton variant="rounded" width={250} sx={{ mt: 1 }} />}>
            <Grid container spacing={2} sx={{ mt: '-5px' }}>
                {[1, 2, 3, 4].map((el) => (
                    <Grid key={el} container item xs={6} alignItems="center" justifyContent="space-between">
                        <Grid item xs="auto" sx={{ minWidth: '148px' }}>
                            <MuiSkeleton variant="rounded" width="80%" height={15} />
                        </Grid>
                        <Grid item xs="auto" sx={{ minWidth: 'calc(100% - 148px)' }}>
                            <MuiSkeleton variant="rounded" width="100%" height={38} />
                        </Grid>
                    </Grid>
                ))}

                <Grid container item xs={12} alignItems="center" justifyContent="space-between">
                    <Grid item xs="auto" sx={{ minWidth: '148px' }}>
                        <MuiSkeleton variant="rounded" width="80%" height={15} />
                    </Grid>
                    <Grid item xs={9} sx={{ minWidth: 'calc(100% - 148px)' }}>
                        <MuiSkeleton variant="rounded" width="100%" height={38} />
                    </Grid>
                </Grid>
            </Grid>
        </FormSection>

        <FormSection title={<MuiSkeleton variant="rounded" width={250} sx={{ mt: 1 }} />}>
            <Grid container spacing={2} sx={{ mt: '-5px' }}>
                {[1, 2, 3, 4].map((el) => (
                    <Grid key={el} container item xs={6} alignItems="center" justifyContent="space-between">
                        <Grid item xs="auto" sx={{ minWidth: '148px' }}>
                            <MuiSkeleton variant="rounded" width="80%" height={15} />
                        </Grid>
                        <Grid item xs="auto" sx={{ minWidth: 'calc(100% - 148px)' }}>
                            <MuiSkeleton variant="rounded" width="100%" height={38} />
                        </Grid>
                    </Grid>
                ))}
            </Grid>
        </FormSection>

        <FormSection title={<MuiSkeleton variant="rounded" width={250} sx={{ mt: 1 }} />}>
            <Grid container item xs={12} spacing={2} sx={{ mt: '-5px' }} alignItems="center" justifyContent="space-between">
                <Grid item xs="auto" sx={{ minWidth: '148px' }}>
                    <MuiSkeleton variant="rounded" width="80%" height={15} />
                </Grid>
                <Grid item xs={9} sx={{ minWidth: 'calc(100% - 148px)' }}>
                    <MuiSkeleton variant="rounded" width="100%" height={38} />
                </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ mt: '-5px' }}>
                {[1, 2, 3, 4, 5, 6].map((el) => (
                    <Grid key={el} container item xs={6} alignItems="center" justifyContent="space-between">
                        <Grid item xs="auto" sx={{ minWidth: '148px' }}>
                            <MuiSkeleton variant="rounded" width="80%" height={15} />
                        </Grid>
                        <Grid item xs="auto" sx={{ minWidth: 'calc(100% - 148px)' }}>
                            <MuiSkeleton variant="rounded" width="100%" height={38} />
                        </Grid>
                    </Grid>
                ))}
            </Grid>
        </FormSection>
    </>
);
